import * as React from 'react';
import LayoutBlock from './layout-block';
import Icon, { IconProps } from './icon';
import classnames from 'classnames';

import './textbox.scss';

const IS_MAC = /Mac/.test(navigator.platform);

export interface TextBoxProps {
	type?: 'text' | 'password' | 'number';
	value?: string;
	maxLength?: number;
	label?: string;
	icon?: IconProps;
	readonly?: boolean;
	placeholder?: string;
	onChange?: (value: string) => any;
	onChanged?: (value: string) => any;
	onSubmit?: () => any;
	className?: string;
}

interface TextBoxState {
	value?: string;
	capsLockEnabled?: boolean;
	showPassword?: boolean;
}
export class TextBox extends React.PureComponent<TextBoxProps, TextBoxState> {
	static defaultProps: TextBoxProps = {
		type: 'text',
		onChange: () => null,
		onChanged: () => null,
		onSubmit: () => null,
	};
	constructor(props: TextBoxProps) {
		super(props);
		this.state = {
			value: props.value || '',
			capsLockEnabled: false,
			showPassword: false,
		};
	}
	componentWillReceiveProps(nextProps: TextBoxProps) {
		this.setState(prevState => ({ value: nextProps.value }));
	}
	onChange(e: React.KeyboardEvent<HTMLInputElement>) {
		var value = e.currentTarget.value;
		this.setState({ value });
		this.props.onChange(value);
	}
	onChanged(e: React.KeyboardEvent<HTMLInputElement>) {
		var value = e.currentTarget.value;
		// if (this.state.value != this.props.value)
		this.props.onChanged(value);
		this.setState({ capsLockEnabled: false });
	}

	handleCorrectStatusCapsLock(e: React.KeyboardEvent<HTMLInputElement>) {
		let charCode = e.charCode;
		let shiftKey = e.shiftKey;
		if (charCode >= 97 && charCode <= 122) {
			this.setState({ capsLockEnabled: shiftKey });
		} else if (charCode >= 65 && charCode <= 90 && !(shiftKey && IS_MAC)) {
			this.setState({ capsLockEnabled: !shiftKey });
		}
	}

	onKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
		switch (this.props.type) {
			case 'password': {
				if (this.state.capsLockEnabled && e.keyCode === 20) {
					this.setState({ capsLockEnabled: false });
				}
				break;
			}
			default:
				break;
		}
	}

	onKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
		if (this.props.type === 'password') {
			this.handleCorrectStatusCapsLock(e);
		}
		switch (e.which) {
			case 13: {
				this.onChanged(e);
				this.props.onSubmit();
				break;
			}
			default:
				break;
		}
	}

	showPassword = () => {
		this.setState({ showPassword: true });
	};

	hidePassword = () => {
		this.setState({ showPassword: false });
	};

	render() {
		let type = this.props.type === 'password' && !!this.state.showPassword ? 'text' : this.props.type;
		return (
			<LayoutBlock
				inline
				fill
				verticalAlign='center'
				className={classnames('textbox', { 'textbox-with-icon': !!this.props.icon }, this.props.className)}
			>
				{this.props.label ? <LayoutBlock className='textbox-label'>{this.props.label}</LayoutBlock> : null}
				{this.props.icon ? (
					<LayoutBlock className='textbox-icon'>
						<Icon {...this.props.icon} />
					</LayoutBlock>
				) : null}

				<input
					type={type}
					placeholder={this.props.placeholder}
					onKeyDown={this.onKeyDown.bind(this)}
					onKeyPress={this.onKeyPress.bind(this)}
					readOnly={this.props.readonly}
					className={classnames('textbox-input')}
					onBlur={this.onChanged.bind(this)}
					value={this.state.value}
					onChange={this.onChange.bind(this)}
					maxLength={this.props.maxLength}
				/>
				{this.state.capsLockEnabled ? (
					<LayoutBlock className='caps-lock-indicator'>
						<Icon icon='warning' color={'yellow'} /> Caps Lock is <span>ON</span>
					</LayoutBlock>
				) : null}
				{this.props.type === 'password' ? (
					<i
						className={classnames('r-input-show-pwd')}
						onTouchEnd={this.hidePassword}
						onTouchCancel={this.hidePassword}
						onTouchStart={this.showPassword}
						onMouseUp={this.hidePassword}
						onMouseOut={this.hidePassword}
						onMouseDown={this.showPassword}
					>
						<Icon icon='review' color={this.state.showPassword ? '#1E90FF' : null} />
					</i>
				) : null}
			</LayoutBlock>
		);
	}
}

export default TextBox;
